import { useEffect } from 'react';

const VoiceflowChat = () => {
  useEffect(() => {
    // Load Voiceflow widget script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    
    script.onload = () => {
      if (window.voiceflow) {
        window.voiceflow.chat.load({
          verify: { projectID: '695c2ac034cad1a725e7c5a6' },
          url: 'https://general-runtime.voiceflow.com',
          versionID: 'production',
          voice: {
            url: "https://runtime-api.voiceflow.com"
          }
        });
        console.log('✓ Voiceflow chat loaded');
      }
    };
    
    script.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs";
    
    // Insert script
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Cleanup
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null; // This component doesn't render anything
};

export default VoiceflowChat;
